const admin = "1";
const lead = "10";
const support = "11";
const boardMember = "9";
const databaseViewer = "12";

export const Menu = [
  {
    name: "Dashboard",
    id: "dashboard",
    to: "/",
    iconClass: "bi bi-speedometer",
    subMenu: false,
    children: [],
    securityKey: [admin, lead, support,boardMember],
  },
  {
    id: "Admin",
    name: "Corporate Membership",
    iconClass: "bi bi-card-checklist",
    subMenu: true,
    securityKey: [admin, lead, support,databaseViewer],
    children: [
      {
        id: "membershipApplicationList",
        submenuName: "Application",
        to: "/membershipApplicationList",
        activePaths: [
        "/memberapplicationtasklistdetailform",
        ],
        securityKey: [admin, lead, support],
      },
      {
        id: "XeroPaymentUpdate",
        submenuName: "Payment Status",
        to: "/xeroPaymentUpdate",
        securityKey: [admin, lead],
      },
      {
        id: "corporateMembers",
        submenuName: "Database",
        to: "/corporateMembers",
        activePaths: [
        "/viewCorporateMember",
        ],
        securityKey: [admin, lead, support,databaseViewer],
      },

    ],
  },
  {
    id: "Board Approval",
    name: "Board Approval",
    iconClass: "bi bi-clipboard-check",
    subMenu: true,
    securityKey: [admin, lead],
    children: [
      {
        id: "boardApprovalUpdate",
        submenuName: "Task List",
        to: "/boardApprovalUpdate",
        securityKey: [admin, lead],
      },
      {
        id: "boardApprovalAssignment",
        submenuName: "Submission for Board Approval",
        to: "/boardApprovalAssignment",
        securityKey: [admin, lead],
      },

    ],
  },
  {
    id: "Key Position",
    name: "Management of Key Representatives",
    iconClass: "bi bi-person-badge",
    subMenu: true,
    securityKey: [admin, lead, support],
    children: [
      // {
      //   id: "Key Position Request",
      //   submenuName: "Key Position Request",
      //   to: "/KeyPositionRequest",
      // },
      {
        id: "viewChangeKeyPosition",
        submenuName: "View Change Request - Key Representative",
        to: "/viewChangeKeyPosition",
        activePaths: [
        "/keyPositionRequest",
        ],
        securityKey: [admin, lead, support],
      },
      {
        id: "ViewChangeKeyPositionCertificateCoordinator",
        submenuName: "View Change Request - Certificate Co-ordinator",
        to: "/ViewChangeKeyPositionCertificateCoordinator",
        securityKey: [admin, lead, support],
      },
    ],
  },
  {
    id: "fieldManagement",
    name: "Portal Management",
    iconClass: "bi bi-sliders",
    subMenu: true,
    securityKey: [admin, lead],
    children: [
      {
        id: "emailTemplateManagement",
        submenuName: "Email Templates",
        to: "/emailTemplateManagement",
        securityKey: [admin, lead],
      },
      {
        id: "dropdownManagement",
        submenuName: "Dropdown Management",
        to: "/dropdownManagement",
        securityKey: [admin, lead],
      },
      {
        id: "corporatePricingTable",
        submenuName: "Membership Pricing Table",
        to: "/corporatePricingTable",
        securityKey: [admin, lead],
      },
      {
        id: "boardMemberManagement",
        submenuName: "Board Member Management",
        to: "/boardMemberManagement",
        securityKey: [admin, lead],
      },
      {
        id: "viewResources",
        submenuName: "Member Resources",
        to: "/viewResources",
        activePaths: [
        "/createResources",
        "/ViewResourceDetails"
        ],
        securityKey: [admin, lead, support],
      },
    ],
  },
  {
    id: "AccountManagement",
    name: "Account Management",
    iconClass: "bi bi-person",
    subMenu: true,
    securityKey: [admin],
    children: [
      {
        id: "createAccount",
        submenuName: "Create Account",
        to: "/createAccount",
        securityKey: [admin],
      },
      {
        id: "viewEditAccount",
        submenuName: "View/Edit Account",
        to: "/viewEditAccount",
        securityKey: [admin],
      },
    ],
  },

  // {
  //   id: "Corporate Members",
  //   name: "Corporate Members",
  //   iconClass: "bi bi-building",
  //   subMenu: true,
  //   securityKey: [admin, lead, support],
  //   children: [
  //     {
  //       id: "corporateMembers",
  //       submenuName: "Corporate Members List",
  //       to: "/corporateMembers",
  //       securityKey: [admin, lead, support],
  //     },
  //   ],
  // },

  // {
  //   id: "SGBSCategory",
  //   name: "SGBS Category",
  //   iconClass: "bi bi-folder2-open",
  //   subMenu: true,
  //   securityKey: [admin, lead, support],
  //   children: [
  //     {
  //       id: "SGBSCategory",
  //       submenuName: "SGBS Category - Criteria Mapping Listing",
  //       to: "/SGBSCategory",
  //       securityKey: [admin, lead, support],
  //     },
  //     {
  //       id: "AddSGBSCategory",
  //       submenuName: "Add SGBS Category - Criteria Mapping Listing",
  //       to: "/AddSGBSCategory",
  //       securityKey: [admin, lead, support],
  //     },
  //   ],
  // },


  // {
  //   id: "Resources",
  //   name: "Resources",
  //   iconClass: "bi bi-folder",
  //   subMenu: true,
  //   securityKey: [admin, lead, support],
  //   children: [
  //     {
  //       id: "viewResources",
  //       submenuName: "View Resources",
  //       to: "/viewResources",
  //       securityKey: [admin, lead, support],
  //     },
  //     {
  //       id: "createResources",
  //       submenuName: "Create Resources",
  //       to: "/createResources",
  //     },
  //   ],
  // },

  {
    id: "ViewApplicationForm",
    name: "SGBS/SGBP Applications",
    iconClass: "bi bi-file-earmark-text",
    subMenu: true,
    securityKey: [admin, boardMember],
    children: [
      {
        id: "viewApplicationTaskList",
        submenuName: "Application Task List",
        to: "/viewApplicationTaskList",
        activePaths: [
        "/viewSGBPApplicationForm",
        "/viewSGBSApplicationForm",
        "/caseOfficerEvaluation",
        "/CertificateGrouping",
        "/CertificateGroupingRequest",
        "/CertificateGroupingCommon",
        "/CertificateGroupingGWPGeneral",
        "/CertificateGroupingTVOC",
        "/CertificateGroupingGWPConcrete",
        "/CertificateGroupingApprove"
        ],
        securityKey: [admin, boardMember],
      },
      // {
      //   id: "viewSGBSApplicationForm",
      //   submenuName: "View SGBS Application Form",
      //   to: "/ViewSGBSApplicationForm",
      //   securityKey: [admin, lead],
      // },
      // {
      //   id: "viewSGBPApplicationForm",
      //   submenuName: "View SGBP Application Form",
      //   to: "/ViewSGBPApplicationForm",
      //   securityKey: [admin, lead],
      // },
    ],
  },
  {
    id: "crud",
    name: "SGBS/SGBP CRUD",
    iconClass: "bi bi-hdd-stack",
    subMenu: true,
    securityKey: [admin],
    children: [
      {
        id: "crudCategory",
        submenuName: "View Categories",
        to: "/crudCategory",
        securityKey: [admin],
      },
      {
        id: "crudRequirement",
        submenuName: "View Requirements",
        to: "/crudRequirement",
        activePaths: [
        "/addRequirement",
        "/editCrudRequirement",
        ],
        securityKey: [admin],
      },
      {
        id: "requirementApproval",
        submenuName: "Approve Requirements",
        to: "/requirementApproval",
        activePaths: [
        "/approveRequirement",
        ],
        securityKey: [admin],
      },
      {
        id: "crudCriteria",
        submenuName: "View Criterias",
        to: "/crudCriteria",
        activePaths: [
        "/addCriteria",
        "/editCriteria",
        "/duplicateCriteria",
        ],
        securityKey: [admin],
      },
      {
        id: "CriteriaApproval",
        submenuName: "Approve Criterias",
        to: "/criteriaApproval",
        activePaths: [
        "/approveCriteria",
        ],
        securityKey: [admin],
      },
    ],
  },
  {
    id: "SGBPCategory",
    name: "Criteria Mapping",
    iconClass: "bi bi-diagram-3",
    subMenu: true,
    securityKey: [admin],
    children: [
      {
        id: "SGBPCategory",
        submenuName: "View Criteria Mapping",
        to: "/SGBPCategory",
        activePaths: [
        "/AddSGBPCategory",
        "/editSGBPCategory",
        ],
        securityKey: [admin],
      },
      {
        id: "ApproveSGBPCategory",
        submenuName: "Approve Criteria Mapping",
        to: "/approveSGBPCategory",
        activePaths: [
        "/approveCategory",
        ],
        securityKey: [admin],
      },
    ],
  },
  // {
  //   id: "evaluationForm",
  //   name: "Evaluation Form",
  //   iconClass: "bi bi-ui-checks",
  //   subMenu: true,
  //   securityKey: [admin],
  //   children: [
  //     {
  //       id: "caseOfficerEvaluation",
  //       submenuName: "Case Officer Evaluation Form",
  //       to: "/caseOfficerEvaluation",
  //       securityKey: [admin],
  //     },
  //     {
  //       id: "PeerReviewerEvaluationApproval",
  //       submenuName: "Peer Reviewer Evaluation Approval",
  //       to: "/PeerReviewerEvaluationApproval",
  //       securityKey: [admin,boardMember],
  //     },
  //   ],
  // },
  // {
  //   id: "certificateGrouping",
  //   name: "Certificate Grouping",
  //   iconClass: "bi bi-collection",
  //   subMenu: true,
  //   securityKey: [admin],
  //   children: [
  //     {
  //       id: "certificateGroupingRequest",
  //       submenuName: "Certificate Grouping Request",
  //       to: "/CertificateGroupingRequest",
  //       securityKey: [admin],
  //     },
  //     {
  //       id: "certificateGrouping",
  //       submenuName: "Certificate Grouping",
  //       to: "/CertificateGrouping",
  //       securityKey: [admin,boardMember],
  //     },
  //     {
  //       id: "certificateGroupingApprove",
  //       submenuName: "Certificate Grouping Approve",
  //       to: "/CertificateGroupingApprove",
  //       securityKey: [admin],
  //     },
  //     {
  //       id: "certificateGroupingCommon",
  //       submenuName: "Certificate Grouping (Common)",
  //       to: "/CertificateGroupingCommon",
  //       securityKey: [admin],
  //     },
  //     {
  //       id: "certificateGroupingGWPGeneral",
  //       submenuName: "Certificate Grouping (GWP General)",
  //       to: "/CertificateGroupingGWPGeneral",
  //       securityKey: [admin],
  //     },
  //     {
  //       id: "certificateGroupingTVOC",
  //       submenuName: "Certificate Grouping (TVOC)",
  //       to: "/CertificateGroupingTVOC",
  //       securityKey: [admin],
  //     },
  //     {
  //       id: "certificateGroupingGWPConcrete",
  //       submenuName: "Certificate Grouping (GWP Concrete)",
  //       to: "/CertificateGroupingGWPConcrete",
  //       securityKey: [admin],
  //     },
  //   ],
  // },
  {
    id: "certificateCorporate",
    name: "Certificate Corporate",
    iconClass: "bi bi-card-checklist",
    subMenu: true,
    securityKey: [admin, lead, support],
    children: [
      {
        id: "certificateCorporateListPage",
        submenuName: "Certificate Corporate List",
        to: "/certificateCorporateListPage",
        activePaths: [
        "/viewCertificateCorporateAccountPage",
        "/productsApplication",
        "/serviceApplication",
        ],
        securityKey: [admin, lead, support],
      },
      // {
      //   id: "viewCertificateCorporateAccount",
      //   submenuName: "View Certificate Corporate Account",
      //   to: "/viewCertificateCorporateAccountPage",
      //   securityKey: [admin, lead, support],
      // },
      // {
      //   id: "productsApplicationDetails",
      //   submenuName: "Products Application Details",
      //   to: "/productsApplication",
      //   securityKey: [admin, lead, support],
      // },
      // {
      //   id: "serviceApplicationDetails",
      //   submenuName: "Service Application Details",
      //   to: "/serviceApplication",
      //   securityKey: [admin, lead, support],
      // },

    ],
  },
  {
    id: "batchCert",
    name: "Batch Cert",
    iconClass: "bi bi-award-fill",
    subMenu: false,
    to: "/batchcert",
    securityKey: [admin],
    children: [],
  },
  {
    id: "generateInvoice",
    name: "Generate Invoice",
    iconClass: "bi bi-receipt",
    subMenu: false,
    to: "/GenerateInvoice",
    securityKey: [admin],
    children: [],
  },

  {
    id: "invoiceApproval",
    name: "Invoice Approval",
    iconClass: "bi bi-check2-square",
    subMenu: false,
    to: "/InvoiceApproval",
    securityKey: [admin],
    children: [],
  },
  // {
  //   id: "analytics",
  //   name: "Analytics",
  //   iconClass: "bi bi-graph-up-arrow",
  //   subMenu: false,
  //   to: "/analytics",
  //   securityKey: [admin, lead],
  //   children: [],
  // },

  {
    id: "XeroPaymentUpdateList",
    name: "Xero Payment Update List",
    iconClass: "bi bi-list-check",
    subMenu: false,
    to: "/XeroPaymentUpdateList",
    securityKey: [admin],
  },
  {
    id: "CertificateIssuance",
    name: "Certificate Issuance",
    iconClass: "bi bi-patch-check",
    subMenu: false,
    to: "/CertificateIssuance",
    securityKey: [admin],
  },
  {
    id: "MetabaseReports",
    name: "Reports",
    iconClass: "bi bi-bar-chart-line",
    subMenu: true,
    securityKey: [admin],
    children: [
      {
        id: "membershipAnalyticsByMonth",
        submenuName: "Membership Analytics By Month",
        to: "/MembershipAnalyticsByMonth",
        securityKey: [admin],
      },
      {
        id: "membershipAnalyticsByYear",
        submenuName: "Membership Analytics By Year",
        to: "/MembershipAnalyticsByYear",
        securityKey: [admin],
      },
      {
        id: "membershipGrowthChart",
        submenuName: "Membership Growth Chart",
        to: "/MembershipGrowthChart",
        securityKey: [admin],
      },
      {
        id: "memberOrganisationCategory",
        submenuName: "Membership Organisation Category",
        to: "/memberOrganisationCategory",
        securityKey: [admin],
      },
      {
        id: "renewalAnalytics",
        submenuName: "Renewal Analytics",
        to: "/renewalAnalytics",
        securityKey: [admin],
      },
      {
        id: "membershipRetentionRateReport",
        submenuName: "Membership Retention Rate Report",
        to: "/MembershipRetentionRateReport",
        securityKey: [admin],
      },
      {
        id: "membershipRetentionRateChart",
        submenuName: "Membership Retention Rate Chart",
        to: "/MembershipRetentionRateChart",
        securityKey: [admin],
      },
      {
        id: "corporateMembershipReport",
        submenuName: "Corporate Member Data Extraction",
        to: "/CorporateMembershipReport",
        securityKey: [admin],
      },
    ],
  },
];